import React, { Component } from "react";
import { RouteComponentProps } from "react-router";
import StoreContext from "./../../../Store/Context";
import { Col, Button } from "reactstrap";
import {
  Ratings,
  PaginationHeader,
  TRIMESTRE_HANDLER,
  validateTokenStorage,
} from "../../Constants/Util";
import { ISetup, INotes } from "./../../Constants/Interfaces";
import { getNotes, validateLogin, getSetup } from "./../../Constants/Services";
import ClipLoader from "react-spinners/ClipLoader";
import { css } from "@emotion/core";
import moment from "moment";

const override = css`
  margin: 0 auto;
  position: relative;
  top: 10px;
  right: 10px;
`;

interface INotesState {
  dataNotes: INotes[];
  dataFormSetup: ISetup;
  loading: boolean;
  trimestre: string;
  formNoteDesc: string;
  not_comment:string;
  see_prom:boolean;
}

class Notes extends Component<RouteComponentProps<{}>, INotesState> {
  static contextType = StoreContext;
  constructor(props: any) {
    super(props);
    this.state = {
      dataNotes: [],
      dataFormSetup: {
        set_registrationy: "",
        set_aniolectivo: "",
        set_startpactivo: new Date().toString(),
        set_endpactivo: new Date().toString(),
        set_start_ft: new Date().toString(),
        set_end_ft: new Date().toString(),
        set_start_st: new Date().toString(),
        set_end_st: new Date().toString(),
        set_start_tt: new Date().toString(),
        set_end_tt: new Date().toString(),
        set_trimestre: "",
      },
      trimestre: "I",
      loading: false,
      formNoteDesc: "",
      not_comment:"",
      see_prom:false
    };
    this.fetchValidateLogin = this.fetchValidateLogin.bind(this);
    this.fetchNotes = this.fetchNotes.bind(this);
    this.setNoteDesc = this.setNoteDesc.bind(this);
    this.fetchSetup = this.fetchSetup.bind(this);
    this.changeHeader = this.changeHeader.bind(this);
    this.rechargeData = this.rechargeData.bind(this);
  }

  async fetchValidateLogin() {
    if (validateTokenStorage()) {
      this.context.quitToken();
    }
    if (this.context.usr_type.replace(/\//g, "") === "parents") {
      const response = await validateLogin(
        this.context.per_id,
        this.context.usr_type.replace(/\//g, "")
      );
      if (response.inactivo) {
        this.context.quitToken();
      }
    } else {
      const response = await validateLogin(
        this.context.per_id,
        this.context.usr_type.replace(/\//g, "")
      );
      if (response.inactivo) {
        this.context.quitToken();
      }
    }
  }

  async fetchNotes({ trimestre }) {
    const props = this.state;
    var response;
    var dataStartTrimestre;
    var dataEndTrimestre;

    if (trimestre === "I") {
      dataStartTrimestre = props.dataFormSetup.set_start_ft;
      dataEndTrimestre = props.dataFormSetup.set_end_ft;
    } else if (trimestre === "II") {
      dataStartTrimestre = props.dataFormSetup.set_start_st;
      dataEndTrimestre = props.dataFormSetup.set_end_st;
    } else if (trimestre === "III") {
      dataStartTrimestre = props.dataFormSetup.set_start_tt;
      dataEndTrimestre = props.dataFormSetup.set_end_tt;
    }

    if (this.context.usr_type.replace(/\//g, "") === "parents") {
      response = await getNotes({
        per_id: this.context.per_std,
        date_week_start: moment(dataStartTrimestre).format("YYYY-MM-DD"),
        date_week_end: moment(dataEndTrimestre).format("YYYY-MM-DD"),
        trimestre:props.trimestre
      });
    } else {
      response = await getNotes({
        per_id: this.context.per_id,
        date_week_start: moment(dataStartTrimestre).format("YYYY-MM-DD"),
        date_week_end: moment(dataEndTrimestre).format("YYYY-MM-DD"),
        trimestre:props.trimestre
      });
    }

    var currentDateObj = new Date(dataEndTrimestre);
    var numberOfMlSeconds = currentDateObj.getTime();
    var addMlSeconds = 1296000000;
    var newDateObj = new Date(numberOfMlSeconds - addMlSeconds);
    var can_see_prom= false;
if (new Date() >= new Date(newDateObj)){
  can_see_prom= true
}
else{
  can_see_prom= false
}
    this.setState({
      dataNotes: response,
      loading: false,
      see_prom:can_see_prom
    });
  }

  async fetchSetup() {
    const response = await getSetup();
    this.setState({
      dataFormSetup: response,
      trimestre: response.set_trimestre,
      loading: false,
    });
    setTimeout(() => {
      this.fetchNotes({ trimestre: response.set_trimestre });
    }, 500);
  }

  componentDidMount() {
    this.fetchValidateLogin();
    this.fetchSetup();
  }

  setNoteDesc({di_desc,not_comment}) {
    if (validateTokenStorage()) {
      this.context.quitToken();
    }
    this.setState({
      formNoteDesc: di_desc,
      not_comment
    });
  }

  changeHeader({ trimestre, operation }: any) {
    var current;
    current = TRIMESTRE_HANDLER(trimestre, operation);
    this.setState({
      trimestre: current,
      formNoteDesc: "",
      not_comment:""
    });

    setTimeout(() => {
      this.fetchNotes({ trimestre: current });
    }, 1000);
  }

  rechargeData() {
    const props = this.state;
    this.setState({ loading: true });
    setTimeout(() => {
      this.fetchNotes({ trimestre: props.trimestre });
    }, 1000);
  }

  render() {
    const props = this.state;
    return (
      <React.Fragment>
        <Col xs={12} className="text-center">
          <h4 className="font-weight-bold">Notas</h4>
        </Col>
        <PaginationHeader
          trimestre={props.trimestre}
          arrow_handler={this.changeHeader}
        />
        <Col xs={12} className="text-right px-0 mx-0 mt-2 mb-2">
          <ClipLoader
            css={override}
            size={23}
            color={"#36D7B7"}
            loading={this.state.loading}
          />
          <Button className="ok mr-2" onClick={() => this.rechargeData()}>
            Recargar
          </Button>
        </Col>
        <Ratings
          dataNote={props.dataNotes}
          setNoteDesc={this.setNoteDesc}
          formNoteDesc={props.formNoteDesc}
          formNoteComment={props.not_comment}
          see_prom={props.see_prom}
        />
      </React.Fragment>
    );
  }
}

export default Notes;
